import { put } from '@/services/put'
import { ApplicationsUpdateStageBody } from '@/types/application/update-stage'

export function updateApplicationsStage(applicationId: string, body: ApplicationsUpdateStageBody) {
  return put<ApplicationsUpdateStageBody, { id: string; stageValue: number | null; stageTarget: number | null }>(
    `/applications/${applicationId}/update-stage`,
    body,
  )
}
